import { Box } from '@mui/material';
import { type FC } from 'react';
import { OC_SCENARIO_SX } from '@/theme/au-compat';

/**
 * El escenario del canal que encabeza el diálogo.
 *
 * Usa `gate-scenario-wide.svg` y no `gate-scenario.svg`: es el asset **redibujado** para este
 * recorte, traído de `digital-product-guidelines` (`public/gate-scenario.svg` en `b4352d2`). El
 * original mide `907.84 × 596.03` —ratio 1,52— contra una caja de 640 × 250 —ratio 2,56—, así que el
 * `cover` le comía más de la mitad del alto; el nuevo mide `636 × 248`, prácticamente el ratio de la
 * caja, y no recorta casi nada.
 *
 * El anterior **se conserva** con su nombre: es el que hay en producción y no se pisa desde acá.
 * Hoy este componente era su único consumidor en el repo, así que queda sin uso hasta que algo lo
 * pida — ese es el punto de no sobrescribirlo.
 *
 * Como el original, trae su propio fondo opaco (`#051c2d`), así que no necesita —ni acepta— una
 * superficie de la paleta debajo.
 */
export const Scenario: FC = () => {
  return (
    <Box
      width="100%"
      height="250px"
      component="img"
      src="/static/gate-scenario-wide.svg"
      alt="Escenario de compuerta"
      sx={OC_SCENARIO_SX}
    />
  );
};
